export const ERROR_FONT_COLOR = '#99310F'
export const FLOW_ERROR_LOG = 'FLOW_ERROR_LOG'
export const FLOW_DEBUG_MAP = 'FLOW_DEBUG_MAP'
export const DEBUG_FORM_VALUE_MAP = 'DEBUG_FORM_VALUE_MAP'
export const DEBUG_JSON_VALUE_MAP = 'DEBUG_JSON_VALUE_MAP'
export const DEBUG_TEST_ID_MAP = 'DEBUG_TEST_ID_MAP'
